// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/alcohol-fitness.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/alcohol-fitness/alcohol-fitness.js';

mount([g0]);
